import React from "react";

function PartnerWithUs() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                Partner with us for seamless trading and growth!
              </h2>
              <p>
                Xeer Technology is a pioneering company in the world of crypto
                market making, dedicated to providing cutting-edge solutions
                that enhance liquidity and stabilize prices for digital assets.
                By leveraging advanced algorithms and custom strategies, Xeer
                Technology ensures seamless market activity, reduces volatility,
                and supports token projects in achieving sustainable growth.
              </p>
              <p>
                Whether you're launching a new token or optimizing liquidity for
                an established asset, Xeer Technology delivers reliable and
                efficient market making services to drive success in the dynamic
                cryptocurrency landscape.
              </p>
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PartnerWithUs;
